import { CarpetaPadreIdEnum, extractIdFromUrl, urlDrive } from '..';
import {
  createFileDocument,
  getDocumentById,
  getDocumentsByIdsArray,
  updateDocument,
} from '../actions/erp/file-document.actions';
import { ArchivoDriveById, FotoType, Nullable } from '../interfaces';

export type UploadManyImagesParams = {
  imageFile: File;
  fileName: string;
  parentDir?: number;
};

export const getUrlsFromImages = (images: ArchivoDriveById[]): string[] => {
  return images.map(img => urlDrive + img.id_archivos + '/descargar');
};
export const getUrlFromImage = (image: ArchivoDriveById): string => {
  return urlDrive + image.id_archivos + '/descargar';
};

export const uploadImageAction = async ({
  imageFile,
  fileName,
  parentDir = CarpetaPadreIdEnum.MAIN,
}: UploadManyImagesParams): Promise<string> => {
  const res = await createFileDocument({
    archivo: imageFile,
    nombre: fileName,
    carpeta_padre: parentDir,
  });

  return urlDrive + res.data.id_archivos + '/descargar';
};

type ReturnUploadImageActionRaw = ArchivoDriveById & { streamUrl?: string };
export const uploadImageActionRaw = async ({
  imageFile,
  fileName,
}: UploadManyImagesParams): Promise<ReturnUploadImageActionRaw> => {
  const res = await createFileDocument({
    archivo: imageFile,
    nombre: fileName,
    carpeta_padre: CarpetaPadreIdEnum.MAIN,
  });

  return {
    ...res.data,
    streamUrl: urlDrive + res?.data?.id_archivos + '/descargar',
  };
};

export const getDocumentByIdDrive = async (
  url?: string
): Promise<Nullable<ArchivoDriveById>> => {
  if (!url) return null;

  const id = extractIdFromUrl(url);
  const res = await getDocumentById(id);
  return res.data;
};

export const updateDocumentByIdDriveNewComponent = async (
  archivoData: Nullable<FotoType>,
  imageFile: File,
  parentDir = CarpetaPadreIdEnum.MAIN
) => {
  if (!archivoData || !imageFile) return null;

  const res = await updateDocument(archivoData.photoId, {
    archivo: imageFile,
    nombre: archivoData.photoName,
    carpeta_padre: parentDir,
  });
  console.log({ res })
  return res.data;
};

export const updateDocumentByIdDrive = async (
  archivoData: Nullable<ArchivoDriveById>,
  imageFile: File
) => {
  if (!archivoData || !imageFile) return null;

  const res = await updateDocument(archivoData.id_archivos, {
    archivo: imageFile,
    nombre: archivoData.nombre,
    carpeta_padre: 1,
  });

  return res.data;
};

export const getDocumentArrByUrlArrDrive = async (
  urls: string[]
): Promise<ArchivoDriveById[]> => {
  const ids = urls.map(url => extractIdFromUrl(url));

  const res = await getDocumentsByIdsArray(ids);

  return res.data;
};
